/* eslint-disable global-require */
/* eslint-disable @typescript-eslint/no-var-requires */
import countries from "i18n-iso-countries";

const registerTerritoryLocales = (): void => {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
};

export default registerTerritoryLocales;
